<template>
  	<EditReseller />
</template>

<script>

// @ is an alias to /src
import EditReseller from "@/components/Client/Resellers/ResellerForm.vue";

export default {
  name: "EditResellers",
  components: {
    EditReseller,
  },
};
</script>
